import { useSelector } from "react-redux";
import { setTableHeight } from "../../../../functions/setTableHeight";
import { visitPendingHeadList } from "../../../../utils/TableHeadList";
import { formatDate } from "../../../../functions/dateTime/formatDate";
import NoDataDisplay from "../../../../components/UI/NoDataDisplay";
import sortDataByDate from "../../../../functions/sorting/sortDataByDate";
import TableHead from "../../../../components/UI/TableUI/TableHead";
import { checkValue } from "../../../../functions/checkValue";
import { truncateDesc } from "../../../../functions/truncateDesc";
import {
  filterTableColumns,
  hasAnyRole,
} from "../../../../utils/tableHeaderConfigh";
import { adminRoles } from "../../../../utils/adminRoles";

const VisitTableContent = ({ openViewDialog }) => {
  const isSorted = useSelector((state) => state.data.isSorted);
  const data = useSelector((state) => state.data.data);
  let dataList = isSorted ? data : sortDataByDate(data, "visitedAt");
  const isDataAvailable = data.length > 0;

  const hasRole = hasAnyRole(adminRoles);
  const filterVisitHeadList = filterTableColumns({
    headList: visitPendingHeadList,
    roleConfig: {
      Supervisor: adminRoles,
    },
  });

  return (
    <div className={`table-container ${setTableHeight(isDataAvailable)}`}>
      <table className={`table ${!isDataAvailable ? "relative" : ""}`}>
        <tbody>
          <TableHead headList={filterVisitHeadList} />
          {isDataAvailable ? (
            <>
              {dataList.map((data, index) => {
                return (
                  <tr className="table-row" key={index}>
                    <td className="text-left">
                      <p className="w-[7rem] whitespace-normal">{data.station.name}</p>
                      <p className="text-xs lg:text-sm text-gray-400 font-normal">
                        SITE ID-{data.station.id}
                      </p>
                    </td>
                    <td>{checkValue(data.operatorPhoneNumber)}</td>
                    <td>{formatDate(data.visitedAt)}</td>
                    <td>{data.fieldTechnician.fullName}</td>
                    {hasRole && <td>{data.supervisor.fullName}</td>}
                    <td>
                      {data.category.name}{" "}
                      {data.category.name === "Complaint" &&
                        ` (${data.category.id})`}
                    </td>
                    <td className="w-72">{truncateDesc(data.workDone)}</td>
                    <td>
                      <button
                        className="tableViewBtn"
                        onClick={() => openViewDialog(dataList[index])}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                );
              })}
            </>
          ) : (
            <NoDataDisplay />
          )}
        </tbody>
      </table>
    </div>
  );
};
export default VisitTableContent;
